import React from 'react';
import {
    CompletionType,
    DEFAULT_COMPLETION_TYPES,
} from '../api/searchAutocomplete';

type SearchInputProviderContextThing =
    | (SearchInputProviderShape & AutocompleteConfig)
    | undefined;

interface AutocompleteConfig {
    usesLanguageSubdirectory?: boolean;
    locale?: string;
    completionTypes?: CompletionType[];
    onAutocompleteCallback?: () => void;
}

interface SearchInputProviderShape {
    query: string;
    setQuery: Function;
}

interface SearchInputProviderProps {
    initialQuery?: string;
}

export const useSearchInputContext = () => {
    const value = React.useContext(SearchInputProviderContext);

    if (value === undefined) {
        throw new Error(
            'useSearchInputContext must be used within SearchInputProvider',
        );
    }

    return value;
};

export const SearchInputProviderContext =
    React.createContext<Partial<SearchInputProviderContextThing>>(undefined);

export const SearchInputProvider: React.FunctionComponent<
    SearchInputProviderProps & AutocompleteConfig
> = (props) => {
    const [query, setQuery] = React.useState(props.initialQuery || '');
    const { usesLanguageSubdirectory, locale, onAutocompleteCallback } = props;

    const completionTypes = props.completionTypes || DEFAULT_COMPLETION_TYPES;

    return (
        <SearchInputProviderContext.Provider
            value={{
                query,
                setQuery,
                usesLanguageSubdirectory,
                locale,
                completionTypes,
                onAutocompleteCallback,
            }}
        >
            {props.children}
        </SearchInputProviderContext.Provider>
    );
};

export default SearchInputProvider;
